import { TextInput } from "@mantine/core";
 import React, { forwardRef } from "react";


 const MantineTextInput = forwardRef<HTMLInputElement, any>((props, ref) => {
  const { label, placeholder, value, onChange, error, classNames, disabled, rightSection, leftSection,style } = props;
  return (
    <TextInput
      classNames={classNames}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      rightSection={rightSection}
      leftSection={leftSection}
      autoComplete="off"
      style={style}
      ref={ref}
      {...props}
    />
  );
});

export default MantineTextInput;
